<mat-toolbar class="small-bar">
  <span>Manual recording</span> <small class="text-muted ms-2"> - measure: {{measureID}}</small>
  <span class="toolbar-spacer"></span>
  <button mat-raised-button color="accent" class="me-2" (click)="resetCounterFromDate()">
    <span translate>RESET_COUNTER</span>
  </button>
  <button mat-raised-button color="primary" (click)="saveRecording()">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>
<div class="container-fluid mt-2">
  <div class="row">
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Value</mat-label>
        <input matInput type="number" placeholder="Value" name="value" [(ngModel)]="recording.value" required>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" placeholder="Date" name="date" [(ngModel)]="recordDateTime.date" [max]="maxRecordDate" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Hour</mat-label>
        <mat-select [(ngModel)]="recordDateTime.hour" name="hour" required >
          @for (h of hours; track h) {
            <mat-option [value]="h">{{h}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Minute</mat-label>
        <mat-select [(ngModel)]="recordDateTime.minute" name="minute" required>
          @for (m of minutes; track m) {
            <mat-option [value]="m">{{m}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>

<mat-toolbar class="small-bar">
  <span>Raw counters (last 100)</span>
</mat-toolbar>

<table class="table table-striped">
  <thead>
    <tr>
      <th>Date</th>
      <th>Value</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (c of counters; track c) {
      <tr>
        <td>{{c.time}}</td>
        <td>{{c.value}} {{c.unit}}</td>
        <td>
          <mat-icon class="cursor-pointer" (click)="confirmDeleteRecording(c)" color="warn">delete</mat-icon>
        </td>
      </tr>
    }
  </tbody>
</table>
@if (!counters || !counters.length) {
  <p>No counter data</p>
}
